enum ViewType {
  Count = 'count',
  Percentage = 'percentage',
  CycleTime = 'cycle_time',
  Cost = 'cost',
}

const VALUE_TYPE_ICONS = {
  [ViewType.Count]: 'looks_one',
  [ViewType.Percentage]: 'percent',
  [ViewType.CycleTime]: 'access_time',
  [ViewType.Cost]: 'payments',
};

enum ProcessViewMode {
  SINGLE = 'single',
  COMPARISON = 'comparison',
}

export { ProcessViewMode, VALUE_TYPE_ICONS, ViewType };
